define([
  'marionette',
  'underscore',
  'js-cookie'
], function (
  Marionette,
  _,
  cookies
) {
  var PRIVACY_LEVEL_ALL = 3

  return Marionette.ItemView.extend({
    template: false,
    ui: {
      btn: '.js-cookie-accept',
      info: '.js-cookie-info',
      cookiebar: '.js-cookiebar',
      modal: '.js-cookiemodal',
      shortInfo: '.js-cookiebar-short',
      selectLevel: '.js-select-level',
      level: '.js-level-radio',
      close: '.js-cookiemodal-close'
    },

    events: {
      'click @ui.btn': 'acceptAll',
      'click @ui.info': 'openMoreInfo',
      'click @ui.selectLevel': 'selectLevel',
      'click @ui.close': 'closeMoreInfo'
    },

    options: {
      cookie: 'cookiepolicy',
      mapping: {},
      currentLevel: '',
      expires: 365,
      animationDuration: 400,
      type: 'string',
      field: ''
    },

    initialize: function () {
      this.levels = _.invert(this.options.mapping)
      if (this.isPrivacyLevelSet()) {
        return
      }

      this.render()
      this.showCookieBar()
    },

    showCookieBar: function () {
      this.ui.cookiebar.removeClass('is-hidden')
    },

    isPrivacyLevelSet: function () {
      return typeof cookies.get(this.options.cookie) !== 'undefined'
    },

    acceptAll: function (e) {
      e.preventDefault()
      this.setCookie(PRIVACY_LEVEL_ALL)
    },

    openMoreInfo: function (e) {
      e.preventDefault()
      this.ui.modal.removeClass('is-hidden')
      this.ui.shortInfo.addClass('is-hidden')
      this.ui.cookiebar.css({ top: 0 })
    },

    closeMoreInfo: function (e) {
      e.preventDefault()
      this.showShortBar()
    },

    showShortBar: function () {
      this.ui.modal.addClass('is-hidden')
      this.ui.shortInfo.removeClass('is-hidden')
      this.ui.cookiebar.css({ top: 'auto' })
    },

    selectLevel: function (e) {
      e.preventDefault()
      this.setCookie(parseInt(this.ui.level.filter(':checked').val()))
    },

    setCookie: function (level) {
      var value = this.levels[level]
      this.ui.cookiebar.fadeOut(this.options.animationDuration)
      if (this.options.type === 'json') {
        var cookie = cookies.get(this.options.cookie)
        cookie = cookie ? JSON.parse(cookie) : {}
        cookie[this.options.field] = value
        value = JSON.stringify(cookie)
      }
      cookies.set(this.options.cookie, value, { expires: this.options.expires })
    }
  })
})
